import React, {useEffect, useState} from 'react';
import Select, { components } from "react-select";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faPlus } from '@fortawesome/free-solid-svg-icons'
import api from '../../api/index.js';
import {callback} from '../../helpers.js';
import Loadable from '../ui/loading/Loadable.js';

import './TaskSelector.scss';


import Spray from './tasks/Spray.js';
import RaspberryPieceRate from './tasks/RaspberryPieceRate.js';
import BlueberryHandpick from './tasks/BlueberryHandpick.js';
import Hourly from './tasks/Hourly.js';


// if custom_interface is defined, use that
// otherwise:

// If pay type is hours
	// Do nothing
// If pay type is plants
	// Pop up row selector
// If pay type is pounds
	// add a pounds field
	
// Maybe when selecting the task, it could add in the component next to it.. That way the component could decide if you need to click something or it just appears there....

// In that case we need:
// AttendancePlants
// AttendancePounds
// (AttendanceHours is in attendance)

const TaskSelector = (props) => {
	// List of tasks
	// Plus additional info
	const [tasks, setTasks] = useState(false);

	const refresh = async () => {
		try {
			let data = await api.getsoft('tasks');
			setTasks(data);
		} catch(e) {
			api.handleExceptions(e);
		};
	}

	useEffect(() => {
		if (tasks === false) {
			refresh();
		}
	});


	const onTaskChange = (e) => {
		// So figure out the default data for each one...
		const comp = task2comp(id2value(e.value).data)
		let newdata = {
			TaskID: e.value,
			data: comp ? comp.getdataformat() : false
		};
		
		// When we change it, copy over any data that is the same between tasks.
		if (props.task !== false) {
			for(var k in props.task.data) {
				if (newdata.data.hasOwnProperty(k))
					newdata.data[k] = props.task.data[k];
			}
		}
		callback(props.onChange, [newdata]);
	}
	
	
	// When the data changes, send the updated task definiton back.
	const taskDataChange = (e) => {
		callback(props.onChange, [{
			TaskID: props.task.TaskID,
			data: e
		}]);
	}

	
	const opt = (a) => {
		return {
				'value': a.TaskID,
				'label': a.TaskName,
				'data': a
			};
	}
	
	const id2value = (id) => {
		if (tasks) {
			for(let i=0; i < tasks.length; i++) {
				if (tasks[i].TaskID === id)
					return opt(tasks[i]);
			}
		}
		return {};
	}
	
	const task2comp = (a) => {
		if (a.CustomInterface) {
			// Do whatever you want!
			// If it's "spray", we want the spray interface.. this is hourly so we don't need to add additional info
			switch(a.CustomInterface) {
				case 'spray':
					return Spray;
			}
		} else {
			switch(a.RateTypeID) {
				case 1: // hourly
				case 5: // hourly
					return Hourly;
				case 3: // Blueberry hand pick
					// We want the lbs field .. and an optional row selector
					return BlueberryHandpick;
				case 4: // Raspberry piece rate
					// We want the row selector .. which calculates the plants field
					return RaspberryPieceRate;
			}
		}
		return false;
	}
	
	
	let value = false;
	let comp = false;
	if (tasks && props.task && props.task.hasOwnProperty('TaskID')) {
		value = id2value(props.task.TaskID);
		comp = React.createElement(task2comp(value.data), {
			data:props.task.data,
			field: props.field,
			date: props.date,
			onChange: taskDataChange
		});
	}
	// I guess I should make it so you can add tasks..
	// Which means you should be able to add rate types
	// Which also means I need a list of valid custom_types; or just types: spray [hours, lbs, plants]

	let options = [];
	if (tasks) 
		options = tasks.map((a)=>{ return opt(a); });
	
	// Figure out the sub component
	// Pass the params to it
	return <Loadable ready={tasks !== false} className="task-selector">
		<div className="select">
		<Select
			classname="selectfield"
			placeholder="Task"
			value={(props.task && props.task.hasOwnProperty('TaskID')) ? id2value(props.task.TaskID) : false}
			options={options}
			onChange={onTaskChange}
		/>
		</div>
		{comp}
		</Loadable>;
}

export default TaskSelector;